// extracted by mini-css-extract-plugin
export default {"pageLayout":"Shipping_pageLayout__NoFpK"};